import * as Sentry from "@sentry/vue";
import { sentryEventFilter } from "@/plugins/sentry/sentryEventFilter";
import { config, envIsLocalOrDev } from "@/config";
import { excludeGraphQLFetch } from "apollo-link-sentry";

const MoneySentry = {
  configure: function (app, { router } = {}) {
    console.log({ sentryConfig: config.sentry }, "Init sentry");
    Sentry.init({
      app,
      ...config.sentry,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration(), Sentry.extraErrorDataIntegration()],
      logErrors: true,
      beforeSend: sentryEventFilter,
      tracePropagationTargets: ["localhost", /^\//],
      beforeBreadcrumb: excludeGraphQLFetch,
      replaysSessionSampleRate: envIsLocalOrDev ? 1 : 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  },
};

export default MoneySentry;
